import { Controller } from "stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["content"];
  static values = { title: String, id: String };

  connect() {
    this.startTippy();
  }

  startTippy() {
    this.tippy = tippy(this.element, {
      content: this.getContent(),
      animation: "perspective-subtle",
      allowHTML: true,
      appendTo: "parent",
    });
  }

  getContent() {
    if (this.hasIdValue) {
      const template = document.getElementById(this.idValue);
      if (!template) {
        console.warn(`Template with id "${this.idValue}" not found.`);
        return "No content";
      }
      return template.innerHTML;
    }

    return this.element.getAttribute("title") || "No content";
  }

  restartTippy() {
    this.disconnect();
    this.startTippy();
  }

  disconnect() {
    this.tippy.destroy();
  }
}
